import AxiosInstance from "./api";

export const CostLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/cost-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/cost-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/cost-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/cost-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/cost-ledgers/" + id);
  },
};
